const MOCK_PRESET_BY_APPLICATION_KEY = "lea_mock_preset_by_application";

export interface StoredApplicationMockPreset {
	presetKey: string;
	step: string;
}

function safeParse(raw: string | null): Record<string, StoredApplicationMockPreset> {
	if (!raw) return {};
	try {
		const value = JSON.parse(raw) as unknown;
		if (value !== null && typeof value === "object" && !Array.isArray(value)) {
			return value as Record<string, StoredApplicationMockPreset>;
		}
	} catch {
		/* ignore */
	}
	return {};
}

export function recordMockPresetForApplication(
	applicationId: string,
	preset: StoredApplicationMockPreset
): void {
	if (typeof window === "undefined") return;
	const map = safeParse(localStorage.getItem(MOCK_PRESET_BY_APPLICATION_KEY));
	map[applicationId] = preset;
	localStorage.setItem(MOCK_PRESET_BY_APPLICATION_KEY, JSON.stringify(map));
}

export function getMockPresetForApplication(
	applicationId: string
): StoredApplicationMockPreset | undefined {
	if (typeof window === "undefined") return undefined;
	return safeParse(localStorage.getItem(MOCK_PRESET_BY_APPLICATION_KEY))[
		applicationId
	];
}
